import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

let products = [
  {
    _id: uuid(),
    name: "Practical Plastic Pants",
    price: "939.00",
    inStock: true,
    fastDelivery: true,
    ratings: 2,
    category: "men",
  },
  {
    _id: uuid(),
    name: "Small Wooden Sausages",
    price: "566.00",
    inStock: true,
    fastDelivery: true,
    ratings: 2,
    category: "men",
  },
  {
    _id: uuid(),
    name: "Sleek Cotton Computer",
    price: "989.00",
    inStock: false,
    fastDelivery: true,
    ratings: 5,
    category: "women",
  },
  {
    _id: uuid(),
    name: "Fantastic Granite Tuna",
    price: "606.00",
    inStock: true,
    fastDelivery: false,
    ratings: 2,
    category: "men",
  },
  {
    _id: uuid(),
    name: "Small Metal Chair",
    price: "160.00",
    inStock: true,
    fastDelivery: true,
    ratings: 5,
    category: "women",
  },
  {
    _id: uuid(),
    name: "Practical Granite Shirt",
    price: "610.00",
    inStock: true,
    fastDelivery: true,
    ratings: 5,
    category: "women",
  },
  {
    _id: uuid(),
    name: "Handcrafted Concrete Bike",
    price: "403.00",
    inStock: true,
    fastDelivery: false,
    ratings: 1,
    category: "others",
  },
  {
    _id: uuid(),
    name: "Rustic Wooden Soap",
    price: "985.00",
    inStock: false,
    fastDelivery: false,
    ratings: 4,
    category: "women",
  },
  {
    _id: uuid(),
    name: "Incredible Metal Ball",
    price: "605.00",
    inStock: true,
    fastDelivery: true,
    ratings: 1,
    category: "others",
  },
  {
    _id: uuid(),
    name: "Generic Rubber Chair",
    price: "375.00",
    inStock: true,
    fastDelivery: true,
    ratings: 2,
    category: "women",
  },
  {
    _id: uuid(),
    name: "Ergonomic Wooden Tuna",
    price: "55.00",
    inStock: true,
    fastDelivery: true,
    ratings: 4,
    category: "kids",
  },
  {
    _id: uuid(),
    name: "Small Concrete Gloves",
    price: "567.00",
    inStock: false,
    fastDelivery: true,
    ratings: 2,
    category: "men",
  },
  {
    _id: uuid(),
    name: "Licensed Rubber Keyboard",
    price: "521.00",
    inStock: true,
    fastDelivery: false,
    ratings: 5,
    category: "kids",
  },
  {
    _id: uuid(),
    name: "Unbranded Steel Bike",
    price: "186.00",
    inStock: false,
    fastDelivery: true,
    ratings: 5,
    category: "women",
  },
  {
    _id: uuid(),
    name: "Unbranded Plastic Sausages",
    price: "390.00",
    inStock: false,
    fastDelivery: true,
    ratings: 4,
    category: "kids",
  },
  {
    _id: uuid(),
    name: "Intelligent Concrete Shirt",
    price: "107.00",
    inStock: true,
    fastDelivery: true,
    ratings: 1,
    category: "others",
  },
  {
    _id: uuid(),
    name: "Unbranded Soft Shoes",
    price: "987.00",
    inStock: false,
    fastDelivery: true,
    ratings: 2,
    category: "others",
  },
  {
    _id: uuid(),
    name: "Unbranded Fresh Hat",
    price: "863.00",
    inStock: true,
    fastDelivery: false,
    ratings: 5,
    category: "women",
  },
  {
    _id: uuid(),
    name: "Unbranded Frozen Gloves",
    price: "841.00",
    inStock: false,
    fastDelivery: true,
    ratings: 3,
    category: "kids",
  },
  {
    _id: uuid(),
    name: "Practical Soft Sausages",
    price: "310.00",
    inStock: false,
    fastDelivery: true,
    ratings: 3,
    category: "men",
  },
];

products = products.map((product) => ({
  ...product,
  quantity: 0,
  price: parseFloat(product.price),
  oldPrice: Math.round(1.5 * product.price),
}));

products = products.map((product) => ({
  ...product,
  discountPercent: Math.round(
    ((product.oldPrice - product.price) / product.oldPrice) * 100
  ),
  image: "https://i.pravatar.cc/300",
}));

export { products };
